<template>
  <div>
    <!--#endregion -->

    <div class="presentation">
     
      <i class="fa fa-arrow-right" aria-hidden="true"></i>
    </div>

    <nav class="float-action-button">
      <a
        @click="navigateToHome"
        class="buttons"
        title="Home"
        data-toggle="tooltip"
        data-placement="left"
      >
        <i class="fa icon_house_alt"></i>
      </a>
      <a
        href="#"
        class="buttons"
           @click="$router.go(-1)"
        title="Previous"
        data-toggle="tooltip"
        data-placement="left"
      >
        <i class="fa arrow_back"></i>
      </a>

      <a
        href="#"
        class="buttons main-button"
        title="Share"
        data-toggle="tooltip"
        data-placement="left"
      >
        <i class=" fa icon_hourglass"></i>
        <i class="fa icon_hourglass"></i>
      </a>
    </nav>
  </div>
</template>

<script>
export default {
  name: "ActionButton",
  methods: {
    navigateToHome() {
      this.$router.push({
        path: "/",
      });

    },
   
  }
}
</script>
<style scoped>
/* presentation purpose */

html:hover .presentation,
body:hover .presentation {
  display: none;
}

.presentation {
  position: fixed;
  right: 0px;
  bottom: 34px;
  text-shadow: 1px 1px 1px #000;
}

/* menu */
nav.float-action-button {
  position: fixed;
  bottom: 0;
  right: 0;
  margin: 1em;
}

a.buttons {
  box-shadow: 0 5px 11px -2px rgba(0, 0, 0, 0.18),
    0 4px 12px -7px rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  width: 59px;
  height: 54px;
  color: #fff;
  font-size: 2.3em;
  padding: 1px 0 0 0;
  text-align: center;
  display: block;
  margin: 18px auto 0;
  position: relative;
  -webkit-transition: all 0.1s ease-out;
  transition: all 0.1s ease-out;
}

a.buttons:active,
a.buttons:focus,
a.buttons:hover {
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.14), 0 4px 8px rgba(0, 0, 0, 0.28);
  text-decoration: none;
}

a.buttons:not(:last-child) {
  width: 40px;
  height: 40px;
  margin: 20px auto 0;
  opacity: 0;
  font-size: 1.6em;
  padding-top: 4px;
  -webkit-transform: translateY(50px);
  -ms-transform: translateY(50px);
  transform: translateY(50px);
}

a.buttons.main-button > i:first-child {
  position: relative;
  margin-top: 10px;
}

nav.float-action-button:hover a.buttons:not(:last-child) {
  opacity: 1;
  -webkit-transform: none;
  -ms-transform: none;
  transform: none;
  margin: 20px auto 0;
}

a.buttons:nth-last-child(1) {
  -webkit-transition-delay: 25ms;
  transition-delay: 25ms;
  background-color: #d32f2f;
  /* Button color */
}

a.buttons:nth-last-child(1) i.fa {
  transform: rotate3d(0, 0, 1, 0);
  transition: content 0.4s, transform 0.4s, opacity 0.4s;
}

a.buttons:nth-last-child(1):hover i.fa {
  transform: rotate3d(0, 0, 1, -180deg);
}

a.buttons:nth-last-child(1) i.fa:nth-last-child(1) {
  position: absolute;
  margin: 10px 0 0 -32px;
}

a.buttons:nth-last-child(1) i.fa:nth-last-child(2) {
  opacity: 0;
}

a.buttons:nth-last-child(1):hover i.fa:nth-last-child(1) {
  opacity: 0;
}

a.buttons:nth-last-child(1):hover i.fa:nth-last-child(2) {
  opacity: 1;
}

a.buttons:not(:last-child):nth-last-child(2) {
  -webkit-transition-delay: 50ms;
  transition-delay: 20ms;
  background-color: #3b5998;
  /* Facebook color */
}

a.buttons:not(:last-child):nth-last-child(3) {
  -webkit-transition-delay: 75ms;
  transition-delay: 40ms;
  background-color: #1da1f2;
  /* Twitter color */
}

a.buttons:not(:last-child):nth-last-child(4) {
  -webkit-transition-delay: 100ms;
  transition-delay: 60ms;
  background-color: #dd4b39;
  /* Google plus color */
}

.tooltip.left {
  margin-left: -10px;
}

/*#region presentation purpose */
.credits {
  font-family: sans-serif;
  font-size: 13px;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 9999;
}

.credits .code-credits {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  color: rgba(255, 255, 255, 0.9);
  display: block;
  max-width: 256px;
  padding: 8px;
}

.credits .code-credits::after {
  content: "";
  display: block;
  clear: both;
}

.credits .code-credits img {
  border-radius: 4px;
  float: left;
  margin-right: 12px;
  width: 64px;
}

.credits .code-credits > div {
  float: left;
}

.credits .code-credits .cc-name {
  font-weight: bold;
  font-size: 16px;
}

.credits .code-credits .cc-follow {
  display: block;
  margin-top: 2px;
}

.credits .code-credits .cc-follow a:last-child {
  margin-left: 4px;
}

.credits .code-credits .cc-follow a:link,
.credits .code-credits .cc-follow a:visited {
  background-color: #eff3f6;
  background-image: linear-gradient(-180deg, #fafbfc, #eff3f6 90%);
  border: 1px solid #d6d6d6;
  border-radius: 4px;
  color: #24292e;
  font-weight: bold;
  letter-spacing: -0.3px;
  padding: 4px 10px;
  text-decoration: none;
}

.credits .code-credits .cc-follow a:hover,
.credits .code-credits .cc-follow a:active {
  color: #fff;
  background-color: #3072b3;
  background-image: -webkit-linear-gradient(#599bdc, #3072b3);
  background-image: -moz-linear-gradient(#599bdc, #3072b3);
  background-image: -ms-linear-gradient(#599bdc, #3072b3);
  background-image: linear-gradient(#599bdc, #3072b3);
  border-color: #518cc6 #518cc6 #2a65a0;
  text-decoration: none;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
}

.credits .code-credits .cc-follow a:first-child:hover,
.credits .code-credits .cc-follow a:first-child:active {
  color: #fff;
  background-color: #000;
  background-image: -webkit-linear-gradient(#555, #000);
  background-image: -moz-linear-gradient(#555, #000);
  background-image: -ms-linear-gradient(#555, #000);
  background-image: linear-gradient(#555, #000);
  border-color: #555 #555 #000;
  text-decoration: none;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
}

.bg-credits {
  background-color: #000;
  border-radius: 4px;
  color: white;
  display: inline-block;
  font-family: sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.2;
  padding: 4px 6px;
  position: fixed;
  top: 10px;
  right: 10px;
  text-decoration: none;
}

/*#endregion */
</style>
